<template>
  <div ref="GrowthDashboardpdf" id="GrowthDashboardpdf">
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <div class="gutr mt-3">
      <div class="row">
        <div class="col-xl-12 col-sm-12 grid-margin stretch-card">
          <div>
            <b-navbar toggleable="lg" type="dark" variant="info">
              <b-navbar-brand style="padding: 0.475rem 1rem">
                <h3>Lead Dashboard</h3>
              </b-navbar-brand>

              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button-group size="sm" class="ml-1 text-right">
                    <b-button variant="outline-secondary" @click="previousDash"
                      >Back</b-button
                    >
                  </b-button-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>

            <div>
              <b-row class="gap-3">
                <b-col md="4" class="my-2">
                  <model-list-select
                    :list="CustomDateList"
                    v-model="QDFilter"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    :isDisabled="QFlag"
                    @input="getCurrentLastDate"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="my-2">
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="DFlag ? true : false"
                    @update="getData"
                  ></date-range-picker>
                </b-col>
                <b-col md="4" class="my-2">
                  <model-list-select
                    :list="$store.getters['common/getAllBranchList']"
                    id="branchfilter"
                    v-model="branchfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="getData"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' ? true : false
                    "
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="my-2">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="ml-1"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                  <b-button class="ml-1" variant="outline-info" @click="getPDF">
                    <i class="fa fa-cloud-download" aria-hidden="true"></i>
                  </b-button>
                  <!-- <b-button
                    size="sm"
                    class="ml-1"
                    @click="getReportsAnalysis('Growth_Dashboard_Invoice_Excel')"
                    variant="outline-info"
                    >Export</b-button
                  > -->
                  <b-button
                    size="sm"
                    class="ml-1"
                    :disabled="ExcelBtnName != 'Export' ? true : false"  
                    @click="getReportsAnalysis('Lead_Master_List', 'Export')"
                    variant="outline-info"
                    > {{ ExcelBtnName }}
                    <b-spinner
                      v-if="ExcelBtnName != 'Export'"
                      small
                      label="Small Spinner"
                    ></b-spinner
                  ></b-button>
                </b-col>
                <b-col md="12" class="mt-5">
                  <table
                    class="table table-bordered table-sm gutr"
                    v-if="leadArr.length > 0"
                  >
                    <tbody>
                      <tr>
                        <th>Month</th>
                        <th>Converted</th>
                        <th>Pending</th>
                        <th>Total</th>
                      </tr>

                      <tr v-for="(rev_item, rev_index) in leadArr" :key="rev_index">
                        <td>{{ rev_item.fromDate + " to " + rev_item.toDate }}</td>
                        <td>
                          <b>
                            {{
                              rev_item.convertedLeadCount
                                ? rev_item.convertedLeadCount
                                : 0
                            }}
                          </b>
                        </td>
                        <td>
                          <b>
                            {{
                              rev_item.pendingLeadCount ? rev_item.pendingLeadCount : 0
                            }}
                          </b>
                        </td>
                        <td>
                          <b>
                            {{ rev_item.totalLeadCount ? rev_item.totalLeadCount : 0 }}
                          </b>
                        </td>
                      </tr>
                      <tr v-if="leadArr.length <= 0">
                        <td colspan="4" style="text-align: center; color: purple">
                          <b>Data Not Found</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
                <b-col md="12" class="mt-5" v-if="$store.getters.appDeviceType !='Phone'">
                  <div
                    class="card card-statistics formCardDash"
                    v-if="series[2].data.length > 0"
                  >
                    <div class="card-body">
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <h6 class="card-title">TOTAL Lead Chart</h6>
                          <div class="fluid-container"></div>
                          <div id="chart">
                            <apexchart
                              v-if="series[2].data.length > 0"
                              type="bar"
                              class="mt-3"
                              height="350"
                              width="500"
                              :options="chartOptions"
                              :series="series"
                            ></apexchart>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import LeadService from "../../services/LeadService.js";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      this.getData();
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  // <router-link to @click.native="$router.push('/dashboard/dashboardReportsDetails/500')">500</router-link>
  data() {
    return {
      // options: {
      //   chart: {
      //     id: "vuechart-example",
      //   },
      //   xaxis: {
      //     categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
      //   },
      // },
      // series: [
      //   {
      //     name: "series-1",
      //     data: [30, 40, 45, 50, 49, 60, 70, 91],
      //   },
      // ],

      series: [
        {
          name: "Total Conveted Leads",
          data: [],
        },
        {
          name: "Total Pending Leads",
          data: [],
        },

        {
          name: "Total Leads",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 430,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
            // horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: false,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        stroke: {
          show: true,
          width: 10,
          colors: ["transparent"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: " (Count)",
          },
        },
        fill: {
          opacity: 8,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return " " + val + " Count";
            },
          },
        },
      },
      ExcelBtnName: "Export",
      QFlag: false,
      DFlag: false,
      CustomDateList: [
        {
          DVal: "Q1",
          DText: "Q1",
        },
        {
          DVal: "Q2",
          DText: "Q2",
        },
        {
          DVal: "Q3",
          DText: "Q3",
        },
        {
          DVal: "Q4",
          DText: "Q4",
        },
        {
          DVal: "H1",
          DText: "H1",
        },
        {
          DVal: "H2",
          DText: "H2",
        },
      ],
      branchList: [],
      branchfilter: "",
      branchfilterName: "",
      QDFilter: "",
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      tabIndex: 0,
      docURL: URL_BASE_DOC,
      leadArr: [],
      dateRangeEnq: "",
      isLoading: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },

  computed: {},
  watch: {},
  methods: {
    getReportsAnalysis(id, btnName) {
      let excelIdGivin = "";
      if (id == "Lead_Master_List") {
        excelIdGivin = "Lead_Master_List";
      }
      let payload = {
        excelId: excelIdGivin,
        dateRange: this.dateRange,
        branchfilter: this.branchfilter,
        QDFilter: this.QDFilter,
      };
      this.ExcelBtnName = "Downloading Please Wait......";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      this.ExcelBtnName = btnName;
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    getCurrentLastDate() {
      this.QFlag = false;
      this.DFlag = false;

      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);
      var firstDay_dd = "";
      var firstDay_mm = "";
      var firstDay_yyyy = "";

      var lastDay_dd = "";
      var lastDay_mm = "";
      var lastDay_yyyy = "";
      if (this.QDFilter) {
        var Qdate = this.QDFilter;
        switch (Qdate) {
          case "Q1": {
            var firstDay = new Date(today.getFullYear(), 3);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);
            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q2": {
            var firstDay = new Date(today.getFullYear(), 6);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q3": {
            var firstDay = new Date(today.getFullYear(), 9);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q4": {
            var firstDay = new Date(today.getFullYear(), 12);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy : firstDay_yyyy - 1) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "H1": {
            var firstDay = new Date(today.getFullYear(), 3);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 6, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "H2": {
            var firstDay = new Date(today.getFullYear(), 9);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 6, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          default: {
            // alert(">41");
          }
        }
        this.QFlag = false;
        this.DFlag = true;
        this.clearFilter();
      } else if (dateRange.fromDate && !this.QDFilter) {
        this.QFlag = true;
        this.DFlag = false;
        this.clearFilter();
      }

      // firstDay = (date('m') > 3) ? date('y') : date('y') - 1;
      // lastDay = (date('m') > 3) ? date('y') + 1 : date('y');

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.getData();
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-light", "text-info"];
      }
    },
    onConfirmDateRangeEq() {
      this.getData();
    },
    previousDash() {
      window.history.go(-1);
    },

    clearFilter() {
      this.QFlag = false;
      this.DFlag = false;
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
      this.branchfilter = "";
      this.branchfilterName = "";
      // this.QDFilter = "";
      this.leadArr = [];

      // this.options = {
      //   chart: {
      //     id: "vuechart-example",
      //   },
      //   xaxis: {
      //     categories: [],
      //   },
      // };
      // this.series = [
      //   {
      //     name: "series-1",
      //     data: [],
      //   },
      // ];

      this.series = [
        {
          name: "Total Conveted Leads",
          data: [],
        },
        {
          name: "Total Pending Leads",
          data: [],
        },

        {
          name: "Total Leads",
          data: [],
        },
      ];
      this.chartOptions = {
        chart: {
          type: "bar",
          height: 430,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
            // horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: false,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: " (Count)",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return " " + val + " Count";
            },
          },
        },
      };
    },

    clearChartData() {
      // this.options = {
      //   chart: {
      //     id: "vuechart-example",
      //   },
      //   xaxis: {
      //     categories: [],
      //   },
      // };
      // this.series = [
      //   {
      //     name: "series-1",
      //     data: [],
      //   },
      // ];

      this.series = [
        {
           name: 'Total Conveted Leads',
          data: [],
        },
        {
          name: 'Total Pending Leads',
          data: [],
        },

        {
           name: 'Total Leads',
          data: [],
        },
      ];
      this.chartOptions = {
        chart: {
          type: "bar",
          height: 430,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
            // horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: false,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: " (Count)",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return " " + val + " Count";
            },
          },
        },
      };
    },

    getData() {
      // return false;
      this.isLoading = true;
      this.branchList = [];
      this.QFlag = false;
      this.DFlag = false;
      this.clearChartData();
      if (this.QDFilter) {
        this.QFlag = false;
        this.DFlag = true;
      } else if (this.dateRange.startDate && this.QDFilter == "") {
        this.QFlag = true;
        this.DFlag = false;
      }
      let payload = {
        itemCode: "LeadDash",
        dateRange: this.dateRange,
        branchfilter: this.branchfilter,
        QDFilter: this.QDFilter,
      };

      LeadService.getAllLeadList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.isLoading = false;
          console.log("Priyanshu SIngh Lead =>", data);
          if (data.leadArr.length > 0) {
            this.leadArr = data.leadArr;
            if (
              this.dateRange.startDate != "" ||
              this.branchfilter != "" ||
              data.DaysDiff > 0 ||
              data.MonthDiff > 0
            ) {
              this.series[0].data = [];
              this.chartOptions.xaxis.categories = [];
              this.leadArr.forEach((element) => {
                let date = new Date(element.fromDate); // 2020-06-21
                // let longMonth = date.toLocaleString('en-us', { month: 'long' }); /* June */
                let shortMonth = date.toLocaleString("en-us", {
                  month: "short",
                }); /* June */
                let pendingLeadCount = element.pendingLeadCount
                  ? parseInt(element.pendingLeadCount)
                  : 0;
                let convertedLeadCount = element.convertedLeadCount
                  ? parseInt(element.convertedLeadCount)
                  : 0;
                let totalLeadCount = element.totalLeadCount
                  ? parseInt(element.totalLeadCount)
                  : 0;
                this.series[0].data.push(convertedLeadCount);
                this.series[1].data.push(pendingLeadCount);
                this.series[2].data.push(totalLeadCount);
                this.chartOptions.xaxis.categories.push(shortMonth);
              });
            }
          } else {
            this.leadArr = [];
          }

          if (data.UserData.length > 0) {
            if (data.UserData[0].designation == "Admin") {
              // this.branchfilter = '';
            } else {
              this.branchfilter = data.UserData[0].baseLocation;
            }
          }
        })
        .catch((error) => {
          console.log("Catch on View_MinutesOfMeetingList Error: ", error);
        });
    },
    getPDF() {
      var HTML_Width = $("#GrowthDashboardpdf").width();
      var HTML_Height = $("#GrowthDashboardpdf").height();

      var top_left_margin = 15;
      var PDF_Width = HTML_Width + top_left_margin * 2;
      var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
      var canvas_image_width = HTML_Width;
      var canvas_image_height = HTML_Height;

      var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      html2canvas($("#GrowthDashboardpdf")[0], { allowTaint: true }).then(function (
        canvas
      ) {
        canvas.getContext("2d");

        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          top_left_margin,
          canvas_image_width,
          canvas_image_height
        );

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage(PDF_Width, PDF_Height);
          pdf.addImage(
            imgData,
            "JPG",
            top_left_margin,
            -(PDF_Height * i) + top_left_margin * 4,
            canvas_image_width,
            canvas_image_height
          );
        }

        pdf.save("Growth_Dashboard_Document" + new Date() + ".pdf");
      });
    },
  },
};
</script>
<style scoped>
.formCard {
  border: none !important;
  padding: 0px;
}
.modal fade show d-block {
  background: none;
}

/*Now the CSS*/
* {
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  padding-left: 2px;
  padding-right: 2px;
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// leadDashboard.vue?ceb4e660